import BigNumber from "bignumber.js";
import { DEFAULT_VALUE } from "./config";

/** 格式化手机号,12345678900 => 123 4567 8900 */
export const formatPhone = (phone?: string) => {
    if (!phone) return DEFAULT_VALUE;
    return phone.replace(/(\d{3})(\d{4})(\d{4})/g, "$1 $2 $3");
};

/** 格式化手机号,用于输入中 */
export const formatterPhone = (value: string) => {
    if (!value || value.length <= 3) return value;
    if (value.length > 3 && value.length <= 7) return `${value.slice(0, 3)} ${value.slice(3)}`;
    return `${value.slice(0, 3)} ${value.slice(3, 7)} ${value.slice(7)}`;
};

/** 格式化银行账号,用于输入中,6311111111122231234 => 631 1111 1111 2223 1234 */
export const formatterBankAccount = (account: string) => {
    // 前3位后加空格，后面每4位字符后加一个空格
    let str = "";
    for (let i = 0; i < account.length; i++) {
        str += account[i];
        if (i === 2 || (i > 2 && (i - 2) % 4 === 0)) {
            str += " ";
        }
    }
    return str.trimEnd();
};

/** 格式化银行账号,6311111111122231234 => 631 1111 1111 2223 1234 */
export const formatBankAccount = (account?: string) => {
    if (!account) return DEFAULT_VALUE;
    return formatterBankAccount(account);
};

/**
 * 格式化数字显示 1234.1 => 1,234.1
 * @param num 数字
 * @param unit 单位
 */
export const fmtNum = (num?: number | string, unit?: string) => {
    if (num === undefined || new BigNumber(num).isNaN()) return DEFAULT_VALUE;
    return new BigNumber(num).toFormat() + (unit || "");
};

/**
 * 格式化金钱显示 1234.1 => 1,234.10
 * @param num 数字
 * @param unit 单位
 */
export const fmtMoney = (num?: number | string, unit?: string) => {
    if (num === undefined || new BigNumber(num).isNaN()) return DEFAULT_VALUE;
    return new BigNumber(num).toFormat(2) + (unit || "");
};

/** 格式化输入框，数字显示 1234.1 => 1,234.1 */
export const fmtInputNum = (value: unknown) => {
    if (typeof value !== "string") return "";
    if (value === "" || value === undefined) return "";
    if (new BigNumber(value).isNaN()) return "";
    let lastStr = value.endsWith(".") ? "." : "";
    lastStr = value.endsWith(".0") ? ".0" : lastStr;
    lastStr = value.endsWith(".00") ? ".00" : lastStr;

    return (new BigNumber(new BigNumber(value).toFixed(2)).toFormat() + lastStr) || DEFAULT_VALUE;
};
